var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4.5C3.67157 4.5 3 5.17157 3 6V18C3 18.8284 3.67157 19.5 4.5 19.5H19.5C20.3284 19.5 21 18.8284 21 18V6C21 5.17157 20.3284 4.5 19.5 4.5H4.5ZM1.5 6C1.5 4.34315 2.84315 3 4.5 3H19.5C21.1569 3 22.5 4.34315 22.5 6V18C22.5 19.6569 21.1569 21 19.5 21H4.5C2.84315 21 1.5 19.6569 1.5 18V6Z",
    fill: "#21272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 7.5C15.3358 7.5 15 7.83579 15 8.25C15 8.66421 15.3358 9 15.75 9C16.1642 9 16.5 8.66421 16.5 8.25C16.5 7.83579 16.1642 7.5 15.75 7.5ZM13.5 8.25C13.5 7.00736 14.5074 6 15.75 6C16.9926 6 18 7.00736 18 8.25C18 9.49264 16.9926 10.5 15.75 10.5C14.5074 10.5 13.5 9.49264 13.5 8.25Z",
    fill: "#21272A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44598 10.876C7.87492 10.4952 8.43309 10.2926 9.00642 10.3096C9.57955 10.3266 10.1246 10.5617 10.5302 10.967C10.5302 10.967 10.5302 10.967 10.5302 10.9671C10.5304 10.9672 10.5305 10.9673 10.5306 10.9674L14.7798 15.2087C15.073 15.5013 15.0735 15.9762 14.7808 16.2694C14.4882 16.5625 14.0133 16.563 13.7202 16.2704L9.47005 12.0282C9.33484 11.893 9.15311 11.8146 8.962 11.8089C8.77092 11.8033 8.5849 11.8708 8.44194 11.9977C8.44191 11.9977 8.44188 11.9977 8.44185 11.9977L2.74835 17.0599C2.4388 17.3351 1.96474 17.3073 1.68951 16.9977C1.41429 16.6882 1.44211 16.2141 1.75167 15.9389L7.44598 10.876Z",
    fill: "#21272A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8225 14.9504C17.6786 14.8309 17.4953 14.7695 17.3085 14.7782C17.1216 14.7868 16.9446 14.8651 16.8124 14.9975L11.0303 20.7796C10.7374 21.0725 10.2626 21.0725 9.96967 20.7796C9.67678 20.4867 9.67678 20.0119 9.96967 19.719L15.7507 13.938C15.7508 13.9378 15.7509 13.9377 15.751 13.9376C16.1476 13.5404 16.6783 13.3058 17.239 13.2798C17.7999 13.2537 18.3502 13.4383 18.7819 13.7973L22.2304 16.6733C22.5485 16.9386 22.5913 17.4116 22.326 17.7297C22.0607 18.0478 21.5877 18.0906 21.2696 17.8253L17.8228 14.9507C17.8227 14.9506 17.8226 14.9505 17.8225 14.9504Z",
    fill: "#21272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.46c382fd36bef85c93ada14cc70c6655.svg";
export { ForwardRef as ReactComponent };